package fr.manyverse.app.presentation.viewmodel

import fr.manyverse.app.domain.model.FeedbackType
import fr.manyverse.app.domain.usecase.SendUserFeedbackUseCase
import fr.manyverse.app.presentation.state.AsyncUiState
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow

class FeedbackViewModel(
    private val sendUserFeedbackUseCase: SendUserFeedbackUseCase
) : BaseViewModel() {

    private val _submitState = MutableStateFlow<AsyncUiState<Unit>>(AsyncUiState.Idle)
    val submitState = _submitState.asStateFlow()

    fun submit(userId: String, userEmail: String, type: FeedbackType, message: String) {
        launchAction(_submitState) {
            sendUserFeedbackUseCase(userId, userEmail, type, message)
        }
    }

    fun reset() {
        resetState(_submitState)
    }
}
